import { routes } from '~/constants';
export const REQUEST_ACCESS_PARAM = 'request-access';
const BULK_CREATE_DRAFTS_ARRIVAL = 'anchor-tax-bulk';
export const isBulkCreateDraftsArrivalValue = (value)=>value === BULK_CREATE_DRAFTS_ARRIVAL;
export const isBulkCreateDraftsArrival = (search)=>isBulkCreateDraftsArrivalValue(new URLSearchParams(search).get(REQUEST_ACCESS_PARAM));
export const bulkCreateDraftsArrivalPath = (search)=>"".concat(routes.vendorDashboard).concat(search);
